import { create } from '@storybook/theming/create';

export default create({
  base: 'light',
  fontBase: '"Inter", sans-serif',
});
